import { apiClient, unwrapApi } from './http';

/**
 * Reports API — /reports/*
 */
export async function getReportsDashboard(params = {}) {
  const { data } = await apiClient.get('/reports/dashboard', { params });
  return unwrapApi(data);
}

export async function getSalesReport(params = {}) {
  const { data } = await apiClient.get('/reports/sales', { params });
  return unwrapApi(data);
}

export async function getExpensesReport(params = {}) {
  const { data } = await apiClient.get('/reports/expenses', { params });
  return unwrapApi(data);
}

export async function getJobsReport(params = {}) {
  const { data } = await apiClient.get('/reports/jobs', { params });
  return unwrapApi(data);
}

export async function getReportsSummary(params = {}) {
  const { data } = await apiClient.get('/reports/summary', { params });
  return unwrapApi(data);
}

export async function getPendingJobsReport(params = {}) {
  const { data } = await apiClient.get('/reports/pending-jobs', { params });
  return unwrapApi(data);
}

export async function getPendingCustomersReport(params = {}) {
  const { data } = await apiClient.get('/reports/pending-customers', { params });
  return unwrapApi(data);
}

export async function getDailyTotals(params = {}) {
  const { data } = await apiClient.get('/reports/daily-totals', { params });
  return unwrapApi(data);
}

const reportsService = {
  getReportsDashboard,
  getSalesReport,
  getExpensesReport,
  getJobsReport,
  getReportsSummary,
  getPendingJobsReport,
  getPendingCustomersReport,
  getDailyTotals,
};

export default reportsService;
